import React from "react";
import { Grid, Skeleton } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";

const MyDriveSkeleton = ({
    folderCount = 3,
    fileCount = 3,
    isMyDrive = false,
    isLabel = true,
    isRecent = false
}) => {
    const { t } = useTranslation();

    return (
        <MuiBox
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                flex: 1,
                width: "100%",
            }}
        >
            {/* My Folders */}
            {!isRecent && <MuiBox
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}
            >
                {isLabel && <MuiTypography
                    fontWeight="600"
                    variant="18"
                    color="text.darkBlack"
                >
                    {isMyDrive ? t("common.myFolders") : t("common.folderCap")}
                </MuiTypography>}

                <Grid container spacing={3}>
                    {Array.from({ length: folderCount }).map((_, index) => (
                        <Grid item key={`folder-${index}`} xs={12} sm={6} md={4} lg={3}>
                            {/* Folder card skeleton – matches FolderCard look */}
                            <MuiBox
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "12px",
                                    p: "12px 14px",
                                    borderRadius: "10px",
                                    bgcolor: "background.blue200",
                                    minHeight: "62px",
                                }}
                            >
                                <MuiBox
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        minWidth: 0,
                                        flex: 1,
                                    }}
                                >
                                    <Skeleton
                                        variant="rounded"
                                        width={28}
                                        height={28}
                                        sx={{ borderRadius: "6px", flexShrink: 0 }}
                                    />
                                    <MuiBox
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "4px",
                                            minWidth: 0,
                                            flex: 1,
                                        }}
                                    >
                                        <Skeleton variant="text" width="70%" height={16} />
                                        <Skeleton variant="text" width="55%" height={12} />
                                    </MuiBox>
                                </MuiBox>
                                <Skeleton
                                    variant="circular"
                                    width={20}
                                    height={20}
                                    sx={{ flexShrink: 0 }}
                                />
                            </MuiBox>
                        </Grid>
                    ))}
                </Grid>
            </MuiBox>}

            {/* My Files */}
            <MuiBox
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}
            >
                {isLabel && <MuiTypography
                    fontWeight="600"
                    variant="18"
                    color="text.darkBlack"
                >
                    {isMyDrive ? t("common.myFiles") : t("common.file")}
                </MuiTypography>}

                <Grid container spacing={3}>
                    {Array.from({ length: fileCount }).map((_, index) => (
                        <Grid item key={`file-${index}`} xs={12} sm={6} md={4} lg={3}>
                            {/* File card skeleton – matches FileCard look */}
                            <MuiBox
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    borderRadius: "10px",
                                    border: "1px solid",
                                    borderColor: "background.gray400",
                                    overflow: "hidden",
                                    bgcolor: "background.white",
                                }}
                            >
                                {/* Thumbnail area */}
                                <Skeleton
                                    variant="rounded"
                                    width="100%"
                                    height={220}
                                    sx={{ borderRadius: 0 }}
                                />

                                {/* Footer: name + date + menu */}
                                <MuiBox
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "8px",
                                        p: "10px 12px",
                                    }}
                                >
                                    <MuiBox
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "4px",
                                            minWidth: 0,
                                            flex: 1,
                                        }}
                                    >
                                        <Skeleton variant="text" width="75%" height={16} />
                                        <Skeleton variant="text" width="50%" height={12} />
                                    </MuiBox>
                                    <Skeleton
                                        variant="circular"
                                        width={20}
                                        height={20}
                                        sx={{ flexShrink: 0 }}
                                    />
                                </MuiBox>
                            </MuiBox>
                        </Grid>
                    ))}
                </Grid>
            </MuiBox>
        </MuiBox>
    );
};

export default MyDriveSkeleton;